<template>
    <div class="al-content">
        <div class="content-top">
            <div class="text-center clearfix">
                <h3 class="al-title ">Mystic Email Config</h3>
            </div>
        </div>
        <div class="btn-group" role="group" aria-label="Basic checkbox toggle button group">
            <div>
                <input type="checkbox" class="btn-check" autocomplete="off"
                       v-show="checkAcl('Read')">
                <label v-show="checkAcl('Read')" :class="{'btn-primary disabled':buttonType=='EmailConfig','btn-outline-default':buttonType!='EmailConfig'}"
                       class="btn btn-outline-default border-white">
                    Email Config
                </label>
            </div>
        </div>

        <!-- Email Config Table -->
        <div class="panel panel-blur with-scroll animated zoomIn" style="max-width:800px;margin-top: 15px;" v-show="buttonType=='EmailConfig'">
            <div class="panel-body">
                <div>
                    <form class="form-horizontal">
                        <div class="form-group row">
                            <label for="Name" class="col-sm-2 control-label">Email Active*</label>
                            <div class="col-sm-10">
                                <div>
                                    <select id="EmailActive" v-model="EmailActiveCafes" class="form-control" multiple="multiple" required style="background: transparent; color: black;">
                                        <optgroup v-for="ven in Vendors" :key="ven.VendorId" :label="ven.CompanyName">
                                            <option v-for="cafe in filteredCafes(ven.VendorId)" :key="cafe.CafeId" :value="cafe.CafeId">
                                                {{cafe.CafeName}}
                                            </option>
                                        </optgroup>
                                    </select>

                                </div>
                                <div style="margin-top: 15px;">
                                    <button type="button" class="btn btn-success" @click="saveConfig">
                                        Save
                                    </button>

                                    <button type="button" class="btn btn-danger" @click="getConfigEmailActive">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>            
        </div>
    </div>
</template>
<style>
    .dataTables_wrapper .dataTables_paginate .paginate_button {
        color: white !important;
    }

    .was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
        color: #00b74a;
        margin-bottom: 0rem !important;
    }

    tr.disabled {
        background-color: #bbbbbb !important;
        color: #a5a5a5 !important;
    }

    .select2-container--bootstrap-5 .select2-selection {
        background-color: transparent;
        
    }
    .select2-container--bootstrap-5 .select2-selection--multiple .select2-selection__rendered .select2-selection__choice{
        color: white;
    }

    .select2-container--bootstrap-5 .select2-dropdown .select2-results__options .select2-results__option[role=group] .select2-results__group{
        font-weight: bold;
        color: black;
    }

    #TemplatesTextarea {
        height: 600px;
    }

    #btn-Preview {
        align-items: flex-start;
    }

  

</style>
<script>

    import $ from 'jquery';

    //https://mdbootstrap.com/docs/b5/vue/components/modal/#docsTabsAPI

    //TimeZone and select2
    import "select2/dist/css/select2.css"
    import "select2/dist/js/select2.min.js"
    import "select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.css"
    //========== Datetime picker
    /*import Datepicker from 'vue3-date-time-picker';*/
    import 'vue3-date-time-picker/dist/main.css'
    import c from '@/mylib/common'
    import { mapState, mapActions } from 'vuex'

    export default {
        name: `Email`,

        data: function () {
            return {
                loaded: false,
                buttonType: 'EmailConfig',

                /*EmailConfig*/
                EmailActiveCafes: [],
                Vendors: null,
                mpCafes: null,

               
            }
        },
        components: {
     
        },
        computed: mapState({
            isCheckedLogin: state => state.view.isCheckedLogin,
            isDemo: state => state.user.isDemo,
            timeZone: state => state.session.timeZone,
            timeOffset: function () {
                const d = new Date();
                return d.getTimezoneOffset();
            },
        }),
        methods: {
            ...mapActions({
                'loading': 'view/setLoading',
                'showModal': 'view/showModal',
                'showToast': 'view/showToast',
                'call': 'api/call'
            }),
            checkAcl(action) {
                return this.$store.state.session.acl.includes(this.$options.name + "/" + action);
            },
            checkFullAcl(router) {
                return this.$store.state.session.acl.includes(router);
            },
            async start() {
                this.buttonType = 'EmailConfig';
                await this.getEmailConfig(); 

                var _this = this;
                $('#EmailActive').select2({
                    theme: "bootstrap-5",
                }).on('change', function () {
                    _this.validateCheck();
                });
 
            },
            validateCheck() {
                this.EmailActiveCafes = $('#EmailActive').val();
            },
          
            formatDate(dstr, notime) {
                if (dstr == null || dstr == "") return 'N/A';

                try {
                    var d = new Date(dstr);
                    d.setTime(d.getTime() - this.timeOffset * 60 * 1000);
                    return c.formatDate(new Date(d), notime);
                } catch (ex) {
                    console.log(ex);
                    return 'N/A';
                }
            },  

            async saveConfig() {
                var cafeids = '';
                for(var i in this.EmailActiveCafes)
                    cafeids = cafeids + this.EmailActiveCafes[i] + ',';
                this.loading(true);
                const rs = await this.call({
                    Action: 'MysticEmailConfig/SaveEmailActiveConfig', Object: {
                        cafeIds: cafeids
                    }
                });
                this.loading(false);
                this.error = rs.Error;
                if (rs.Error != "") {
                    this.showToast({ isShow: true, title: '', content: rs.Error, type: 'error' });
                } else {                   
                    this.showToast({
                        isShow: true, title: '', content: `<span style="font-weight:bold">Save Email Active</span> <span style="font-weight: bold;color: blue;"> successful!</span> `, type: 'success'
                    });

                   
                }
                await this.getEmailConfig();
            },
            
        

            async getEmailConfig() {
                await this.getConfigEmailActive();   
                await this.getAllVendor();
                await this.getVendorCafe();                
               
            },

            async getConfigEmailActive() {

                //Get EmailActive Cafe list
                this.loading(true);
                const rs = await this.call({ Action: 'MysticEmailConfig/GetConfigEmailActive' });
                this.loading(false);
                this.error = rs.Error;
                if (rs.Error != "") {
                    //show modal with callback name = loginView to check it whenever modal confirm triggerConfirm
                    this.showModal({ isShow: true, title: 'Error', content: rs.Error, type: 'error' });
                    //no permission
                    if (rs.Data == "nopermission") {
                        window.history.back();
                    }
                } else {
                    var listcafe = rs.Data["CafeIds"].split(',');
                    this.EmailActiveCafes = listcafe;
                    $('#EmailActive').val(this.EmailActiveCafes).trigger('change');                    
                }               
            },

            async getAllVendor() {
                try {
                    //Get Vendor list
                    this.loading(true);
                    const rs = await this.call({ Action: 'MysticEmailConfig/GetAllVendor' });

                    this.loading(false);
                    this.error = rs.Error;
                    if (rs.Error != "") {
                        //show modal with callback name = loginView to check it whenever modal confirm triggerConfirm
                        this.showModal({ isShow: true, title: 'Error', content: rs.Error, type: 'error' });
                        //no permission
                        if (rs.Data == "nopermission") {
                            window.history.back();
                        }
                    } else {
                        this.Vendors = rs.Data;                       

                    }
                } catch (error) {
                    console.error("getAllVendor",error);
                }
                
            },

            async getVendorCafe() {
                try {
                    //Get Map cafe list
                    this.loading(true);
                    const rs = await this.call({ Action: 'MysticEmailConfig/GetVendorCafe' });
                    this.loading(false);
                    this.error = rs.Error;
                    if (rs.Error != "") {
                        //show modal with callback name = loginView to check it whenever modal confirm triggerConfirm
                        this.showModal({ isShow: true, title: 'Error', content: rs.Error, type: 'error' });
                        //no permission
                        if (rs.Data == "nopermission") {
                            window.history.back();
                        }
                    } else {
                        this.mpCafes = rs.Data;                       
                    }
                } catch (error) {
                    console.error("getVendorCafe: ", error);
                }
            }, 

            filteredCafes(vendorId) {
                if (this.mpCafes && this.mpCafes[vendorId] && Array.isArray(this.mpCafes[vendorId])) {
                    return this.mpCafes[vendorId].filter(function (cafe) {
                        return cafe != null;
                    });
                }
                return [];
            },

        },
        mounted() {
            //if already login then start,
            //else will watch isCheckedLogin to catch its change
            //to call start function
            if (this.isCheckedLogin) this.start();
            //const startDate = new Date();
            //const endDate = new Date(new Date().setDate(startDate.getDate() + 7));
            //this.date.value = [startDate, endDate];

            

        },
        watch: {
            //catch status from not login to logged in
            //to call start function.
            //Apply for reload page issue
            isCheckedLogin(newVal) {
                if (newVal) {
                    this.start();
                }
            },            
        },
    };
</script>
